import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@chatterbug/aaron'

import { t } from 'src/lib/i18n-react'
import ProgressBar from 'src/ui/ProgressBar/ProgressBar'

import StudyGoalsSkeleton from './StudyGoalsSkeleton'
import SingleStudyGoal from './subcomponents/SingleStudyGoal/SingleStudyGoal'
import SingleStudyGoalProgress from './subcomponents/SingleStudyGoalProgress/SingleStudyGoalProgress'
import LiveLessonGoal from 'src/ui/LiveLessonGoal/LiveLessonGoal'

const containerStyles = {
  bg: 'white100',
  boxShadow: 'overlay',
  borderRadius: '1x',
  p: { _: '2x', tablet: '3x' },
  pb: { _: '1x', tablet: '2,5x' },
  overflow: 'hidden',
}

const StudyGoals = ({
  animateCompletion,
  weeklyGoals,
  liveLessonGoals,
  isStacked,
  title,
  linkSection,
  subtitle,
}) => {
  const {
    goal: weeklyGoal,
    completed: weeklyCompleted,
    completeFraction: weeklyCompleteFraction,
  } = weeklyGoals
  const {
    goal: liveLessonGoal,
    completed: liveLessonsCompleted,
  } = liveLessonGoals
  return (
    <StudyGoalsSkeleton
      title={title}
      subtitle={subtitle}
      linkSection={linkSection}
      isStacked={isStacked}
      liveLessonGoalSection={
        <Box {...containerStyles}>
          <LiveLessonGoal
            isStacked={isStacked}
            numRequiredLessons={liveLessonGoal}
            numCompletedLessons={liveLessonsCompleted}
          />
        </Box>
      }
      weeklyGoalSection={
        <Box {...containerStyles}>
          <SingleStudyGoal
            title={t('Study')}
            numericProgressSection={
              <SingleStudyGoalProgress
                completed={weeklyCompleted}
                goal={weeklyGoal}
                unit="minutes"
              />
            }
            progressBarSection={
              <ProgressBar
                size="thick"
                animateCompletion={animateCompletion}
                completeFraction={weeklyCompleteFraction}
                customWidth="100%"
              />
            }
          />
        </Box>
      }
    />
  )
}

StudyGoals.propTypes = {
  animateCompletion: PropTypes.bool,
  weeklyGoals: PropTypes.object.isRequired,
  liveLessonGoals: PropTypes.object.isRequired,
  isStacked: PropTypes.bool,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  linkSection: PropTypes.any,
}

export default StudyGoals
